export const getTransactionPointsPlusPay = (cashTotal, pointsTotal) => {
  const paymentTypes = [];
  if (!pointsTotal.isZero()) paymentTypes.push('Points');
  if (!cashTotal.isZero()) paymentTypes.push('Cash');
  return paymentTypes.join(' + ');
};
